import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import AddUserComponent from '../../components/AddUserComponent/AddUserComponent'

const AddUser = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <AddUserComponent/>
                </div>
            </div>
        </div>
    )
}

export default AddUser
